import { Typo } from 'component/Typo'
import { observer } from 'mobx-react-lite'
import { opt } from 'store/opt'

type Props = {
  children: string
}

export const SectionTitle = observer(({ children }: Props) => {
  const size = opt.stand ? 16 : opt.tsum ? 15 : 13

  return (
    <Typo size={size} upper medium>
      {children}
    </Typo>
  )
})
